import { createContext, useContext } from "react";
import type { SubmissionForm } from "../../types/submission";

export interface SubmissionContextValue {
    detail: SubmissionForm;
    /** Replace the detail in the parent layout state (called after a
     *  successful save, e.g. after the server returns the refreshed
     *  payload). */
    setDetail: (detail: SubmissionForm) => void;
    /** "create" while the layout is mounted at /submissions/new with a
     *  blank detail, "edit" once the detail has a real id. The form
     *  uses this to pick POST vs PATCH on save. */
    mode: "create" | "edit";
    /** True while the Schedule section is surfacing its duplicate-
     *  submission warning banner. Lifted out of the Schedule page so
     *  the submission nav can flag the Schedule item while the banner
     *  is up. */
    scheduleHasWarning: boolean;
    /** Persists "BOR received" — PATCHes the submission's
     *  `is_bor_received` to true, which clears the warning. Wired to the
     *  banner's "Mark BOR as Received" action. */
    markBorReceived: () => void;
}

export const SubmissionContext = createContext<SubmissionContextValue | null>(null);

export function useSubmissionContext(): SubmissionContextValue {
    const ctx = useContext(SubmissionContext);
    if (!ctx) {
        throw new Error("useSubmissionContext must be used inside <SubmissionLayout>");
    }
    return ctx;
}
